import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import dayjs from "../utils/dayjs";
import { Alarms } from "../actions/apiActions";
import { addDeviceNameToGetAllAlarmLimitsResponse } from "./alarmsLimitsDuck";

export const alarmsHistoryDefaultState = {
  entries: [],
  formattedEntries: {},
};

export const getAllDeviceAlarmsHistory = createAsyncThunk(
  "alarmsHistory/getAllDeviceAlarmsHistory",
  async (systemId, thunk) => {
    const { config } = thunk.getState().config[systemId].system;
    const devicesEntries = thunk.getState().config[systemId].devicesConfigs.entries;
    if (config) {
      const timestamp = dayjs().subtract(1, "week").unix();
      const payload = {
        TriggerTimeStamp: timestamp,
        customerId: config.CUSTOMER_ID,
        deviceId: config.DEVICE_ID,
      };
      const response = await Alarms.getAllAlarmsHistory(config.DATA_URL, payload);
      return { response, devicesEntries, systemId };
    }
  }
);

const alarmsHistorySlice = createSlice({
  name: "alarmsHistory",
  initialState: alarmsHistoryDefaultState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getAllDeviceAlarmsHistory.fulfilled, (state, action) => {
      const data = action.payload.response;
      const devicesEntries = action.payload.devicesEntries;
      const dataWithDeviceNames = addDeviceNameToGetAllAlarmLimitsResponse(data, devicesEntries);
      state.entries = dataWithDeviceNames;
    });
  },
});

export const { } = alarmsHistorySlice.actions;

export default alarmsHistorySlice.reducer;
